import { Component, ViewChild } from '@angular/core';
import {
  ConfirmEventType,
  ConfirmationService,
  MessageService,
} from 'primeng/api';
import { SpinnerLoadingComponent } from '../spinner-loading/spinner-loading.component';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css'],
  providers: [ConfirmationService, MessageService],
})
export class DialogComponent {
  constructor(
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) {}
loading = false;
mode: 'default' | 'pdf' | 'excel' = 'default';
  @ViewChild('spinner') spinner!: SpinnerLoadingComponent;

  /**
   * @description Show cancel button
   */
  cancelButton!: boolean;

  /**
   * @description Show confirm action dialog
   * @param fx Alternative function
   * @param message Message of the dialog
   * @param header Header of the dialog
   */
  confirm(message: string, header: string, fx?: Function, cancelFx?: Function) {
    this.cancelButton = true;
    this.confirmationService.confirm({
      message: message,
      header: header,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        fx ? fx() : null;
      },
      reject: (type: ConfirmEventType) => {
        cancelFx ? cancelFx() : null;
        switch (type) {
          case ConfirmEventType.REJECT:
            this.messageService.add({
              severity: 'error',
              summary: 'Rechazado',
              detail: 'Se ha rechazado la acción',
            });
            break;
          case ConfirmEventType.CANCEL:
            this.messageService.add({
              severity: 'warn',
              summary: 'Cancelado',
              detail: 'Se ha cancelado la acción',
            });
            break;
        }
      },
    });
  }
  /**
   * @description Start loading screen
   */
 start(mode: 'default' | 'pdf' | 'excel' = 'default') {
  this.mode = mode;
  this.loading = true;
}
  /**
   * @description Stop loading screen and send success message
   */
stop(message: string, header: string, fx?: Function, error?: boolean) {
  setTimeout(() => {
    this.loading = false;
    this.mode = 'default'; // reset
    this.cancelButton = false;
    this.success(message, header, fx!, error);
  }, 300);
}

  /**
   * @description Show success action dialog
   * @param fx Alternative function
   * @param message Message of the dialog
   * @param header Header of the dialog
   */
  success(message: string, header: string, fx?: Function, error?: boolean) {
    this.cancelButton = false;
    this.confirmationService.confirm({
      message: message,
      header: header,
      icon: !error ? 'pi pi-check' : 'pi pi-exclamation-triangle',
      accept: () => {
        fx ? fx() : null;
      },
      reject: () => {
        fx ? fx() : null;
      },
    });
  }
}
